import React, { useMemo, useState } from 'react'
import { Card, CardContent, Typography, Box, Button, Tooltip } from '@mui/material'
import moment from 'moment'
import { ClaimDialog } from './ClaimDialog'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { grey } from '@mui/material/colors'
import { useAuth } from '../../api/context/UserAuthContext'

const useStyles = makeStyles((theme) => ({
  expired: { backgroundColor: grey[100], color: grey[600] },
}))

export const StaffBenefitCard = (props) => {
  const { staffBenefit } = props
  const [openClaim, setOpenClaim] = useState(false)
  const classes = useStyles()
  const { user } = useAuth()

  const { redeemed } = staffBenefit
  const { department } = user

  const { count, isFullyRedeemedUser } = useMemo(() => {
    let count = 0
    if (redeemed) {
      let staff = redeemed.find((e) => e.user === user.id)
      count = staff?.count ?? 0
    }

    let limitPerUser

    if (staffBenefit.departments?.length > 0) {
      limitPerUser = staffBenefit.departments.find(
        (x) => x.department === department
      )?.redemptionPerUser
    } else {
      limitPerUser = staffBenefit?.redemptionPerUser
    }

    return { count, isFullyRedeemedUser: count >= limitPerUser }
  }, [staffBenefit, redeemed, user])

  const isFullyReemed =
    staffBenefit.departments?.length > 0
      ? staffBenefit.departments.find((x) => x.department === department)
          ?.redemptionPerDepartment &&
        staffBenefit.count >=
          staffBenefit.departments.find((x) => x.department === department)?.redemptionPerDepartment
      : staffBenefit.redemptionLimit && staffBenefit.count >= staffBenefit.redemptionLimit

  const handleClose = () => {
    setOpenClaim(false)
  }

  const handleOnClickClaim = (event) => {
    setOpenClaim(!openClaim)
  }

  const userRedemptionLimit =
    staffBenefit.departments?.length > 0
      ? staffBenefit.departments.find((x) => x.department === department)?.redemptionPerUser
      : staffBenefit?.redemptionPerUser

  return (
    <>
      <Card
        style={{ minHeight: '180px' }}
        className={clsx({
          [classes.expired]: isFullyReemed || isFullyRedeemedUser,
        })}
      >
        <Tooltip title={isFullyRedeemedUser || isFullyReemed ? 'Fully redeemed' : ''}>
          <Box display='flex' flexDirection='column' justifyContent='space-between'>
            <CardContent style={{ minHeight: '70px' }}>
              <Box>
                <Typography style={{ fontWeight: 'bold' }}>{staffBenefit?.message}</Typography>
              </Box>
            </CardContent>

            <CardContent position='relative'>
              <Box display='flex' flexDirection='row' justifyContent='space-between'>
                <Box>
                  <Typography variant='body2'>
                    <b>Redemption Per User</b>: {count}/{userRedemptionLimit}
                  </Typography>
                  <Typography variant='body2'>
                    <b>End Date</b>: {moment(staffBenefit?.endDate).format('D/M/YYYY')}
                  </Typography>
                </Box>
                <Button
                  variant='contained'
                  onClick={handleOnClickClaim}
                  disabled={isFullyReemed || isFullyRedeemedUser}
                >
                  Claim
                </Button>
              </Box>
            </CardContent>
          </Box>
        </Tooltip>
      </Card>
      <ClaimDialog openClaim={openClaim} onClose={handleClose} staffBenefit={staffBenefit} />
    </>
  )
}
